import api from 'api';

export const SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_START = 'SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_START';
export const SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS = 'SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS';
export const SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR = 'SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR';
export const SEASONAL_FLOW_DESIGN_TEMPLATES_RESET_STATE = 'SEASONAL_FLOW_DESIGN_TEMPLATES_RESET_STATE';

function seasonalFlowDesignTemplatesAsyncActionStart() {
  return {
    type: SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  };
}

function seasonalFlowDesignTemplatesAsyncActionError(error) {
  return {
    type: SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
    error,
  };
}

function seasonalFlowDesignTemplatesAsyncActionSuccess(data) {
  return {
    type: SEASONAL_FLOW_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetseasonalFlowDesignTemplatesState() {
  return {
    type: SEASONAL_FLOW_DESIGN_TEMPLATES_RESET_STATE,
  };
}

export function getseasonalFlowThemeDesignTemplates(themeid) {
  return (dispatch, getState) => {
    dispatch(seasonalFlowDesignTemplatesAsyncActionStart());
    return api.request(
      `theme/design/DesignTemplates?themeid=${ themeid }`,
      'get',
      null
    )
    .then((data) => {
      dispatch(seasonalFlowDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(seasonalFlowDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}
